<template>
  <v-container>
    <v-form
      v-model="formValid"
      @submit="pay"
      @submit.prevent
      class="d-flex justify-center"
    >
      <v-text-field
        label="Kredit"
        dense
        style="max-width: 150px"
        class="mr-5"
        type="number"
        :rules="[rules.required, rules.moneyMin(1)]"
        v-model="form.amount"
        min="1"
        outlined
      >
      </v-text-field>
      <v-btn
        color="lightGreen"
        class="btn btn-green-gradient"
        label="Uložit"
        @click="pay"
        :disabled="!formValid || wait"
        type="submit"
        required
        dark
      >
        Dobít
      </v-btn>
    </v-form>
  </v-container>
</template>

<script>
import rules from '../../mixins/rules'

export default {
  name: 'TopUpCredit',
  mixins: [rules],
  data () {
    return {
      wait: false,
      form: {
        amount: null
      },
      formValid: true
    }
  },
  methods: {
    pay () {
      this.wait = true
      this.$http.post('/credits/charge', this.form)
        .then(response => {
          window.location.replace(response.data)
        })
    }
  }
}
</script>

<style scoped>

</style>
